import {styled} from '@esgi/ui/theme';
import {Box} from '@esgi/ui/layout';

export const FixedBox = styled(Box, {
	maxWidth: '500px',
});